/**
 * Teacher resources — empty stub for now.
 */
import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTeacherAuth } from "../TeacherAuthContext";

export default function TeacherResources() {
  const { status, teacher, signingOutRef } = useTeacherAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (status === "anon" && !signingOutRef.current) navigate("/teachers", { replace: true });
    else if (status === "auth" && teacher?.must_change_password) navigate("/teachers/profile", { replace: true });
  }, [status, teacher, navigate, signingOutRef]);

  if (status !== "auth") return null;
  if (teacher?.must_change_password) return null;

  return (
    <main className="min-h-[100dvh] bg-[#FAF9F6] pt-20 md:pt-24 pb-24 px-6 md:px-10" data-testid="teacher-resources-page">
      <div className="max-w-3xl mx-auto">
        <Link to="/teachers/dashboard" className="inline-block text-[10px] tracking-[0.28em] uppercase text-[#1C1C1C]/55 hover:text-[#1C1C1C] mb-6 transition-colors">
          ← Dashboard
        </Link>
        <h1 className="font-display text-4xl md:text-6xl leading-tight tracking-tighter font-light text-[#1C1C1C]">
          Resources.
        </h1>
        <div className="mt-10 bg-white border border-[#1C1C1C]/10 rounded-2xl p-10 text-center">
          <div className="text-[10px] tracking-[0.32em] uppercase font-medium text-[#1C1C1C]/55 mb-3">
            Coming soon
          </div>
          <p className="text-[#1C1C1C]/70 leading-relaxed">
            We'll publish teaching materials, lesson plans, and references here.
            For now, please use whatever you've been provided directly by the school.
          </p>
        </div>
      </div>
    </main>
  );
}
